// extracted by mini-css-extract-plugin
export var fadeInOut = "_31-3";
export var icon = "_31-4";
export var savedIndicator = "_31-2";
export var savingIndicator = "_31-0";
export var spin = "_31-1";